import { AppButton, AppSwitchBox } from 'components';
import useSubjectPlans from 'hooks/API/GET/useSubjectPlans';
import useManageSubjectPlans from 'hooks/API/useManageSubjectPlans';
import useToaster from 'hooks/useToaster';
import { Link, useParams } from 'react-router-dom';

function MainSubjectPlans() {
  const { classID } = useParams();

  const { data, isLoading, isError } = useSubjectPlans({ classID });
  const { subjects = [], masterPlans = [] } = data?.data || {};

  const managePlan = useManageSubjectPlans({ classID });
  useToaster(managePlan.isLoading, { type: managePlan.isError ? 'error' : 'success' });

  function updateData(apiData = {}) {
    if (managePlan.isLoading) return;

    managePlan.mutate(apiData);
  }

  return (
    <div className="mainWraper">
      <div className="container-fluid">
        <div className="row">
          <div className="col-6">
            <h2 className="prime-head p-0">Manage Class Plans {`&`} Subjects</h2>
          </div>
          <div className="col-6 prime-head text-right">
            <Link to="/manage/classes">
              <AppButton variantClass="btn-plane p--tint mx-2">&#8701; Back</AppButton>
            </Link>
          </div>
        </div>

        {isLoading ? (
          'Loading...'
        ) : isError ? (
          'Failed to load'
        ) : (
          <>
            <div className="table-responsive mt-4">
              <table className="table">
                <thead className="thead-light __appTheadColor">
                  <tr>
                    <th scope="col"></th>
                    {masterPlans?.map?.((masterPlan) => {
                      return (
                        <th scope="col" key={masterPlan._id}>
                          {masterPlan.name}
                        </th>
                      );
                    })}
                  </tr>
                </thead>
                <tbody>
                  {subjects?.map?.((item) => {
                    const { subject, plans = [] } = item;
                    return (
                      <tr key={subject._id}>
                        <th scope="row">{subject.name}</th>
                        {masterPlans?.map?.((masterPlan, i) => {
                          const checked = plans?.map?.((p) => p._id)?.includes?.(masterPlan._id);
                          return (
                            <td key={`${masterPlan._id}-${subject._id}`}>
                              <AppSwitchBox
                                inputProps={{
                                  checked,
                                  onChange: () => {
                                    const modifiedSubjects = subjects?.map?.((element) => {
                                      // Identify the subject in which the clicked plan belongs
                                      const isCurrentSubject =
                                        element?.subject?._id === subject._id;

                                      // if subject not found; do nothing
                                      if (isCurrentSubject) {
                                        // if subject found;
                                        // then if the plans array already has the selected plan; then remove it; else add it
                                        const planExists = element?.plans?.find?.(
                                          (p) => p._id === masterPlan._id
                                        );
                                        element.plans = planExists
                                          ? plans?.filter?.((p) => p._id !== masterPlan._id)
                                          : plans?.concat?.(masterPlan);
                                      }

                                      return element;
                                    });

                                    const data = { subjects: modifiedSubjects };

                                    updateData(data);
                                  },
                                }}
                                labelProps={{ label: ' ' }}
                              />
                            </td>
                          );
                        })}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default MainSubjectPlans;
